import React, { Component } from "react";
import DocumentsForm from "../DocumentsForm/DocumentsForm";
import "filepond/dist/filepond.min.css";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import {Button} from "rsuite";

class Others extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentDocument: null
    }
  }
  componentDidMount() {
    this.props.fetch(this.props.currentProjectID);
  }

  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
          <SmallModal>
            <DocumentsForm
                type={"other"}
                add={this.props.add}
                update={this.props.update}
                projectID={this.props.currentProjectID}
                toggleSmallModalHandler={this.props.toggleSmallModalHandler}
                currentDocument={this.state.currentDocument}
            />
          </SmallModal>
      );
    }



    return (
      <div className="container-fluid">
          {this.props.disabled ? null : (
              <div
                  style={{textAlign: "right"}}
              >
            <Button
                className="my-2"
                color="blue"
                onClick={() => {
                  this.setState({currentDocument: null});
                  this.props.toggleSmallModalHandler();
                }}
            >
              Upload Documents
            </Button>
              </div>
          )}
        {smallModal}

        <h1>Documents</h1>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Link</th>
              <th>Source</th>
              <th>Security Level</th>
              <th>Description</th>
              <th>Time Stamp</th>
                {this.props.disabled ? null : (<th>Delete</th>)}
            </tr>
          </thead>
          <tbody>
            {/*todo: change this part when new findFileByID api is ready.*/}
            {this.props.documents
              .filter(
                document =>
                  document.file_type !== "video" &&
                  document.file_type !== "picture" &&
                    document.file_type !== "stakeholder_picture" &&
                    document.file_type !== "stakeholder_video"
              )
              .map(document => (
                  <tr key={document.upload_tstamp}
                      onClick={e => {
                        if (e.target.type !== "button" && e.target.tagName.toLowerCase() !== 'a') {
                          this.setState({
                            currentDocument: document
                          });
                          this.props.toggleSmallModalHandler();
                        }
                      }}
                  >
                  <td>{document.file_name}</td>
                  <td>
                    <a href={document.file_url} target={"_blank"}>Click to download</a>
                  </td>
                  <td>{document.file_source}</td>
                  <td>{document.security_level}</td>
                  <td>{document.file_description}</td>
                  <td><span className={"text-nowrap"}>{document.upload_tstamp.slice(0, 10)}&nbsp;{document.upload_tstamp.slice(11, 16)}</span></td>
                    {this.props.disabled ? null : (
                      <td>
                        <Button
                            type="button"
                            color="red"
                            onClick={() => {
                                this.props.delete(document.project_file_id);
                            }}
                        >
                            Delete
                        </Button>
                      </td>
                        )}
                </tr>
              ))}
          </tbody>
        </table>

      </div>
    );
  }
}

export default Others;
